var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellDot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.229 18.875a3.786 3.786 0 107.541 0h-2.017a1.786 1.786 0 11-3.507 0H8.23z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.713 9.699a7.244 7.244 0 017.242-6.9c3.873 0 7.06 3.04 7.242 6.9l.147 3.147c.072 1.53.472 3.027 1.174 4.389l.566 1.097a.084.084 0 01.011.045.096.096 0 01-.015.045.1.1 0 01-.033.034.088.088 0 01-.047.01H3.142a.234.234 0 01-.21-.34l.46-.891a10.668 10.668 0 001.174-4.389L4.713 9.7z",
    fill: "#010101",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 5,
    r: 4,
    fill: "#F66"
  })));
}
export default SvgBellDot;